<template>
  <div>
    <lv-tooltip styling="primary" :options="{placement: 'top-start'}" :class="$style.tooltipWrapper">
      <template #tooltip>
        <div v-html="$awt(`${tokenBase}.before_calculator_tooltip_content`)" />
      </template>
      <template #reference>
        <span>
          <lv-icon name="information-circle-16" :size="22" :class="$style.tooltipIcon" />
          <span :class="$style.tooltipText" v-html="$awt(`${tokenBase}.before_calculator_tooltip_reference`)" />
        </span>
      </template>
    </lv-tooltip>
    <div v-html="$awt('aw.cetelem.before_calculator_text')" />
    <div :id="cetelemBlockId" :class="[$style.cetelemBlock, {[$style.cetelemBlockSmall]: smallHeight, [$style.cetelemBlockCheckout]: isCheckout}]" />
  </div>
</template>
<script setup>
  import { onMounted, onUnmounted, useCssModule } from 'vue';
  import { useId, useNuxtApp } from 'nuxt/app';
  import { LvIcon, LvTooltip } from '~~/common/components/loginet-vue-shop/index';

  const props = defineProps({
    cetelemBaremId: {
      type: Number,
      required: true,
      default: 0,
    },
    tokenBase: {
      type: String,
      required: true,
    },
    purchaseAmount: {
      type: Number,
      required: true,
    },
    smallHeight: {
      type: Boolean,
      default: false,
    },
    isCheckout: {
      type: Boolean,
      default: false,
    },
  });
  const $style = useCssModule();
  const {
    $logger,
    $awRuntimeConfig,
    $awMergedConfig,
  } = useNuxtApp();
  const cetelemBlockId = `aw-cetelem-block-${useId()}`;
  let isUnmounting = false;

  onMounted(() => {
    insertCetelem();
  });
  onUnmounted(() => {
    isUnmounting = true;
  });

  function insertCetelem () {
    const id = 'cetelem-script';
    let cetelemScriptTag = document.getElementById(id);
    if (!cetelemScriptTag) {
      cetelemScriptTag = document.createElement('script');
      cetelemScriptTag.src = $awRuntimeConfig.cetelemScriptTagUrl;
      cetelemScriptTag.id = id;
      document.body.appendChild(cetelemScriptTag);
    }
    if (window.Cetelem) {
      insertCetelemCalculator();
    } else {
      cetelemScriptTag.addEventListener('load', () => {
        insertCetelemCalculator();
      });
    }
  }

  function insertCetelemCalculator () {
    try {
      if (isUnmounting) {
        return;
      }
      const calc = new window.Cetelem.Ecommerce.Calculator({
        shopCode: `${$awMergedConfig.cetelemShopCode}`,
        barem: `${props.cetelemBaremId}`,
        purchaseAmount: `${props.purchaseAmount}`,
        url: `${$awRuntimeConfig.cetelemCalculatorUrl}`,
        duration: '0',
        ownShare: '0',
      });
      calc.iframe(
        460,
        (props.smallHeight
          ? $style.iframeSmallHeight
          : $style.iframeBigHeight
        ),
        `#${cetelemBlockId}`,
      );
    } catch (err) {
      $logger.error(err);
    }
  }
</script>

<style module lang="scss" rel="stylesheet/scss">
$iframeSmallHeight: 230px;
$iframeBigHeight: 270px;

.tooltip {
  &Wrapper {
    margin-top: 16px;
  }

  &Icon {
    color: white;
    fill: $color-pelorous;
  }

  &Text {
    font-size: 13px;
    line-height: 20px;
    margin-left: 4px;
  }
}

.cetelemBlock {
  width: 100%;
  margin-top: 8px;
  margin-bottom: 24px;
  border: 8px solid white;
  border-radius: 8px;
  background: white;

  iframe {
    width: 100%;
    height: $iframeBigHeight;
  }

  &Small {
    iframe {
      height: $iframeSmallHeight;
    }
  }

  &Checkout {
    margin-top: 0;
    margin-bottom: 8px;
    border-width: 0;
  }
}

:export {
  iframeSmallHeight: $iframeSmallHeight;
  iframeBigHeight: $iframeBigHeight;
}
</style>
